import './Info.scss'
import logo from './agroai.jpg'
import { useNavigate } from 'react-router-dom'

export const Info = () => {
    
    const navigate = useNavigate()

    const navAI = () => {
        navigate(`/aiv1`)
    }

    return (
        <>
        {/* <div className="container">
        <div class="circle left"></div>
        <div class="circle right"></div>
        </div> */}
        <div className="info-container">
            <img src={logo} alt="logo" />
            <h3>By <u>Tech Titans</u>, MIT WPU</h3>
            <p>
AgroAI is an advanced AI-driven solution designed to assist farmers by diagnosing plant diseases through symptom analysis. It provides actionable insights and treatment recommendations, helping farmers maintain healthy crops and optimize yields. This tool offers real-time, precise diagnostics and is tailored to address various plant health issues.
Developed for the SIH Hackathon, AgroAI leverages cutting-edge technology to support agricultural efficiency and sustainability.</p><br></br>
            <p>Developed by six students in MIT WPU, this AI-powered tool aims to revolutionize the way farmers diagnose plant diseases.</p>
            <div className="footer">
            <p className="footer">Developed with ❤️ by Divyansh Pathak, Dhruv Patel, Shivani Joshilkar, Parnav Mangsulekar, Manthan Jikardara, Sunny Pandey under the guidance of Dr. Maithilee Patawar and Prof. Mamta Bhamare</p>
            </div>
            <span onClick={navAI} className="material-symbols-outlined">cancel</span>
        </div>  
        </>
    )
}